import React, { useEffect } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { useTheme } from "../hooks/useTheme";

export const PageLayout = ({ children, title, showBackgroundOrbs = false }) => {
  useTheme();
  useEffect(() => {
    if (title) document.title = title;
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [title]);

  return (
    <div className="App min-h-screen relative">
      {showBackgroundOrbs && (
        <div className="fixed inset-0 -z-10 osx-orbs" aria-hidden>
          <div className="osx-orb osx-orb--1" />
          <div className="osx-orb osx-orb--2" />
          <div className="osx-orb osx-orb--3" />
        </div>
      )}
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
};
